import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { NgxSpinnerService } from 'ngx-spinner';
import { switchMap } from 'rxjs';
import { contactUsApi } from 'src/app/services/constants/api.constants';
import { Toast } from 'src/app/services/enums/toast';
import { HelpersService, ToastService, HttpBaseService } from '@evento-ng/libs';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
  contactUsForm!: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService,
    private toast: ToastService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private helpers: HelpersService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  submit(): void {
    this.spinner.show();

    this.recaptchaV3Service
      .execute('contactUs')
      .pipe(
        switchMap((token: any) => {
          const body = {
            ...this.contactUsForm.value,
            recaptcha: token,
            mobile: this.contactUsForm.value.mobile.number,
            mobileRegionCode: this.contactUsForm.value.mobile.countryCode,
          };
          return this.dataService.post(`${contactUsApi}`, body, {
            headers: { 'Accept-Language': this.translate.currentLang },
          });
        })
      )
      .subscribe({
        next: () => {
          this.spinner.hide();
          this.contactUsForm.reset({
            fullName: '',
            email: '',
            mobile: { number: '', countryCode: '' },
            subject: '',
            message: '',
          });
          this.toast.show('Success', this.translate.instant('message sent'), {
            classname: Toast.success,
          });
        },
        error: (err: any) => {
          this.spinner.hide();
          this.toast.show('Error', err.error.message, {
            classname: Toast.error,
          });
          console.error(err);
        },
      });
  }

  private initForm(): void {
    const emailPattern = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';

    this.contactUsForm = this.formBuilder.group({
      fullName: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(40),
          this.helpers.noOnlyWhitespaceValidator(),
        ],
      ],
      email: ['', [Validators.required, Validators.pattern(emailPattern)]],
      mobile: ['', [Validators.required]],
      subject: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(40),
          this.helpers.noOnlyWhitespaceValidator(),
        ],
      ],
      message: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(40),
          this.helpers.noOnlyWhitespaceValidator(),
        ],
        ,
      ],
    });
  }
}
